import { render, staticRenderFns } from "./RequesterForm.vue?vue&type=template&id=3c6a3225"
import script from "./RequesterForm.vue?vue&type=script&lang=ts"
export * from "./RequesterForm.vue?vue&type=script&lang=ts"
import style0 from "./RequesterForm.vue?vue&type=style&index=0&id=3c6a3225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports